export const FORM_NAME = 'webcamRecordingForm';
export const STREAM = 'stream';
export const STREAM_ERROR = 'streamError';
export const AUDIO = 'audioDeviceIds';
export const VIDEO = 'videoDeviceIds';
export const STEP = 'step';
export const TIMER_EXPIRY_TIME = 'timerExpiryTime';
export const RECORDED_FILE = 'recordedFile';
export const RECORDER = 'recorder';
export const RECORDER_STATE = 'recorder_state';
export const RECORDER_STATES = {
  RECORDING: 'recording',
  PAUSED: 'paused',
  WILL_RESUME: 'willResume',
  RESUME: 'resume',
};

export const STEPS = {
  CONFIGURATION: 'configuration',
  RECORDING: 'recording',
  PREVIEW: 'preview',
};

export const STREAM_ERRORS = {
  DEVICE_NOT_FOUND: 'devicesNotFoundError',
  DEVICE_ALREADY_IN_USE: 'deviceAlreadyInUse',
  PERMISSION_DENIED: 'permissionDenied',
  UNKNOWN: 'unknown',
};

export const WEBCAM_RECORDING_DIALOG = 'webcamRecordingDialog';
export const TIMER_EXPIRY = 60 * 15;
